import { ActionsUnion, createAction } from "@redux/helpers";
import {
  BRAND_LIST,
  COUNTRY,
  DelFavoritesItemPayload,
  FavoritesItemData,
  ItemWishlistData,
  PostFavoritesItemPayload
} from "@type/index";

export const GET_FAVORITES_ITEM = "[favorites item] get favorites item request";
const GET_FAVORITES_ITEM_SUCCESS =
  "[favorites item] get favorites item success";
const GET_FAVORITES_ITEM_LOADING =
  "[favorites item] get favorites item loading";
export const POST_FAVORITES_ITEM =
  "[favorites item] post favorites item request";
const FAVORITES_ITEM_POST_SUCCESS =
  "[favorites item] favorites item post success";
export const DELETE_FAVORITES_ITEM =
  "[favorites item] del favorites item request";
const FAVORITES_ITEM_DELETE_SUCCESS =
  "[favorites item] favorites item delete success";
const INIT_FAVORITES_ITEM = "[favorites item] init favorites item";

export const Actions = {
  getFavoritesItem: () => createAction(GET_FAVORITES_ITEM),
  getFavoritesItemSuccess: (payload: {
    data: Array<FavoritesItemData>;
    region: string;
    brand: string;
  }) => createAction(GET_FAVORITES_ITEM_SUCCESS, payload),
  getFavoritesItemLoading: (payload: boolean) =>
    createAction(GET_FAVORITES_ITEM_LOADING, payload),
  postFavoritesItem: (payload: PostFavoritesItemPayload) =>
    createAction(POST_FAVORITES_ITEM, payload),
  postFavoritesItemSuccess: (payload: string) =>
    createAction(FAVORITES_ITEM_POST_SUCCESS, payload),
  delFavoritesItem: (payload: DelFavoritesItemPayload) =>
    createAction(DELETE_FAVORITES_ITEM, payload),
  delFavoritesItemSuccess: (payload: string) =>
    createAction(FAVORITES_ITEM_DELETE_SUCCESS, payload),
  initFavoritesItem: () => createAction(INIT_FAVORITES_ITEM)
};

type ActionType = ActionsUnion<typeof Actions>;

export type State = ItemWishlistData;

const initialState = {
  itemLoading: false,
  favoritesItemList: []
};

export default (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case GET_FAVORITES_ITEM_SUCCESS: {
      const { data, region, brand } = action.payload;
      let arr = [];
      // GUHK
      if (brand === BRAND_LIST.GU && region === COUNTRY.HK) {
        arr = data.map((k) => k.spuInfo.productCode || "");
      }
      // GUTW & UQTW & UQHK
      else {
        arr = data.map((k) => k.summaryInfo.productCode || "");
      }
      arr = Array.from(new Set(arr));
      return {
        ...state,
        favoritesItemList: [...arr],
        itemLoading: false
      };
    }
    case GET_FAVORITES_ITEM_LOADING: {
      return {
        ...state,
        itemLoading: action.payload
      };
    }
    case INIT_FAVORITES_ITEM: {
      return {
        ...state,
        favoritesItemList: []
      };
    }
    case FAVORITES_ITEM_POST_SUCCESS: {
      const itemId = action.payload;
      const newItemId = state.favoritesItemList.filter(
        (item) => item === `${itemId}`
      );
      const itemIds = newItemId.length
        ? state.favoritesItemList
        : [...state.favoritesItemList, itemId];
      return {
        ...state,
        itemLoading: false,
        favoritesItemList: [...itemIds]
      };
    }
    case FAVORITES_ITEM_DELETE_SUCCESS: {
      const itemId = action.payload;
      const itemIds = [...state.favoritesItemList];
      if (itemIds.includes(itemId)) {
        itemIds.splice(itemIds.indexOf(itemId), 1);
      }
      return {
        ...state,
        itemLoading: false,
        favoritesItemList: [...itemIds]
      };
    }
    default:
      return state;
  }
};
